/**
 * Mobile Navigation -- Hess Sound Drill-Down Drawer
 * Drawer open/close, Panel navigation, Escape handler, Scroll lock
 *
 * [H2-Fix] Focus-Trap: Tab bleibt im Drawer
 * [H3-Fix] aria-hidden auf Page-Content wenn Drawer offen
 * [M8-Fix] aria-expanded Reset bei Escape-Close
 */
(function () {
  'use strict';

  var drawer = document.getElementById('hs-mob-drawer');
  if (!drawer) return;

  var overlay = document.getElementById('hs-mob-overlay');
  var hamburger = document.querySelector('.hs-mega-header__mobile-toggle button');
  var closeBtn = document.getElementById('hs-mob-close');
  var hiddenState = [];
  var previousBodyOverflow = '';

  /* prefers-reduced-motion: Drawer-/Panel-Timeouts auf 0 fahren, wenn CSS-Transitions
     auf 0.01ms reduziert sind. Sonst wirken Focus-Sprung und Panel-Reset verzoegert. */
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduceMotion = motionQuery.matches;
  if (motionQuery.addEventListener) {
    motionQuery.addEventListener('change', function (e) { reduceMotion = e.matches; });
  }
  function d(ms) { return reduceMotion ? 0 : ms; }

  /* Modality-Tracking: bei Touch/Mouse keinen programmatischen Fokus setzen
     (Mobile Safari triggert sonst :focus-visible und zeigt Focus-Ring nach Tap).
     Bei Keyboard schon -- damit Tab-User nach Panel-Navigation den Back-Button
     fokussiert vorfinden. */
  var lastInteraction = 'touch';
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ' ||
        e.key === 'Escape' || e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
        e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      lastInteraction = 'keyboard';
    }
  }, true);
  document.addEventListener('mousedown', function () { lastInteraction = 'touch'; }, true);
  document.addEventListener('touchstart', function () { lastInteraction = 'touch'; }, true);
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'touch') return;
    lastInteraction = 'touch';
  }, true);

  /* [H3-Fix] Page-Content-Elemente fuer aria-hidden Toggle.
     Shopify wrappt die Section in einen shopify-section-Container, der als
     Body-Child rendert. Drawer, Overlay, Panels und Close-Button liegen alle
     innerhalb dieses Containers. Wir muessen also den gesamten Section-Root
     vom aria-hidden-Toggle ausnehmen, sonst wird der Drawer selbst versteckt. */
  function getDrawerSectionRoot() {
    var node = drawer;
    while (node && node.parentNode && node.parentNode !== document.body) {
      node = node.parentNode;
    }
    return node;
  }

  function getPageContent() {
    var drawerRoot = getDrawerSectionRoot();
    var elements = [];
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el !== drawerRoot && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE') {
        elements.push(el);
      }
    }
    return elements;
  }

  function setPageContentHidden(isHidden) {
    if (isHidden) {
      hiddenState = [];
      getPageContent().forEach(function (el) {
        hiddenState.push({
          el: el,
          ariaHidden: el.getAttribute('aria-hidden')
        });
        el.setAttribute('aria-hidden', 'true');
      });
      return;
    }

    hiddenState.forEach(function (item) {
      if (item.ariaHidden === null) {
        item.el.removeAttribute('aria-hidden');
      } else {
        item.el.setAttribute('aria-hidden', item.ariaHidden);
      }
    });
    hiddenState = [];
  }

  /* [H2-Fix] Focus-Trap: alle fokussierbaren Elemente im sichtbaren Bereich.
     Close-Btn und Panels liegen AUSSERHALB des Drawers (Panels ab Restructure-Fix
     fuer position:fixed-Korrektheit). Deshalb query via document. */
  function getFocusableInDrawer() {
    var activePanel = document.querySelector('.hs-mob-panel.is-active');
    var scope = activePanel || drawer;
    var all = scope.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var visible = [];
    if (closeBtn && closeBtn.offsetParent !== null && !activePanel) visible.push(closeBtn);
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) visible.push(all[i]);
    }
    return visible;
  }

  /* -- Drawer -- */
  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    /* [H3-Fix] Page-Content verstecken fuer Assistive Tech */
    setPageContentHidden(true);

    /* [H2-Fix] Fokus auf Close-Button setzen -- nur bei Keyboard-Modality,
       sonst zeigt Mobile Safari einen unerwuenschten Focus-Ring nach Tap. */
    if (closeBtn && lastInteraction === 'keyboard') {
      setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, d(100));
    }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = previousBodyOverflow;
    previousBodyOverflow = '';

    /* [H3-Fix] Page-Content wieder sichtbar fuer Assistive Tech */
    setPageContentHidden(false);

    /* [M8-Fix] aria-expanded auf Hamburger zuruecksetzen */
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');

    // Panels erst nach Drawer-Transition resetten (MDRL-07, 300ms = CSS transition-duration)
    setTimeout(closeAllPanels, d(300));
  }

  /* -- Panels -- */
  /* Drawer-Scroll sperren, solange mindestens ein Panel offen ist, damit
     Scroll-Events nicht zum Drawer durchschlagen koennen (iOS-Rubberband). */
  function syncDrawerScrollLock() {
    var anyActive = !!document.querySelector('.hs-mob-panel.is-active');
    drawer.style.overflow = anyActive ? 'hidden' : '';
  }

  function openPanel(panelId, opener) {
    var panel = document.getElementById(panelId);
    if (!panel) return;
    if (opener) {
      panel.__opener = opener;
      if (opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'true');
    }
    panel.classList.add('is-active');
    panel.scrollTop = 0;
    syncDrawerScrollLock();

    /* [H2-Fix] Fokus auf Zurueck-Button im neuen Panel -- nur bei Keyboard. */
    var backBtn = panel.querySelector('.hs-mob-back');
    if (backBtn && lastInteraction === 'keyboard') {
      setTimeout(function () { backBtn.focus({ preventScroll: true }); }, d(100));
    }
  }

  function closePanel(panelId) {
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var opener = panel.__opener;
    panel.classList.remove('is-active');
    syncDrawerScrollLock();

    if (opener && opener.hasAttribute('aria-expanded')) {
      opener.setAttribute('aria-expanded', 'false');
    }

    if (opener && typeof opener.focus === 'function' && lastInteraction === 'keyboard') {
      setTimeout(function () {
        opener.focus({ preventScroll: true });
      }, d(50));
    }
    panel.__opener = null;
  }

  function closeAllPanels() {
    document.querySelectorAll('.hs-mob-panel').forEach(function (p) {
      p.classList.remove('is-active');
      if (p.__opener && p.__opener.hasAttribute('aria-expanded')) {
        p.__opener.setAttribute('aria-expanded', 'false');
      }
      p.__opener = null;
    });
    syncDrawerScrollLock();
  }

  /* -- Event Delegation (auf document, da Panels Siblings des Drawers sind) -- */
  document.addEventListener('click', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    // Panel oeffnen
    var openTrigger = e.target.closest('[data-panel-open]');
    if (openTrigger) {
      e.preventDefault();
      openPanel(openTrigger.getAttribute('data-panel-open'), openTrigger);
      return;
    }
    // Panel schliessen (Zurueck-Button)
    var closeTrigger = e.target.closest('[data-panel-close]');
    if (closeTrigger) {
      e.preventDefault();
      closePanel(closeTrigger.getAttribute('data-panel-close'));
      return;
    }
  });

  /* [H2-Fix] Focus-Trap: document-level, weil Panels Siblings des Drawers sind */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    if (!drawer.classList.contains('is-open')) return;
    var focusable = getFocusableInDrawer();
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* -- Escape: tiefstes Panel zuerst, dann Drawer (A11Y-07) -- */
  /* [M8-Fix] aria-expanded wird jetzt auch bei Escape zurueckgesetzt (via closeDrawer) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!drawer.classList.contains('is-open')) return;
    var activePanels = document.querySelectorAll('.hs-mob-panel.is-active');
    if (activePanels.length > 0) {
      closePanel(activePanels[activePanels.length - 1].id);
    } else {
      closeDrawer();
      if (hamburger && lastInteraction === 'keyboard') hamburger.focus({ preventScroll: true });
    }
  });

  /* -- Hamburger-Trigger (aus mega-menu.liquid) -- */
  if (hamburger) {
    hamburger.addEventListener('click', function (e) {
      e.preventDefault();
      // aria-expanded auf dem Hamburger-Button (A11Y-02)
      hamburger.setAttribute('aria-expanded', 'true');
      openDrawer();
    });
  }

  /* -- Close-Button -- */
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeDrawer();
      if (hamburger && lastInteraction === 'keyboard') hamburger.focus({ preventScroll: true });
    });
  }

  /* -- Overlay-Klick schliesst Drawer -- */
  if (overlay) {
    overlay.addEventListener('click', function () {
      closeDrawer();
      if (hamburger && lastInteraction === 'keyboard') hamburger.focus({ preventScroll: true });
    });
  }

  /* -- Sprache: Proxy-Click auf Weglots native Footer-Elemente --
     Weglot bindet Click-Handler an #weglot-language-de / #weglot-language-en.
     Wir klicken diese programmatisch, nutzen Weglots nativen Switch-Flow 1:1
     (kein Hard-Reload, kein Redirect-Bounce).

     Wichtig: Weglot muss ready sein BEVOR der native Click ausgeloest wird —
     sonst navigiert der Link zu href="/en" und Shopify bouncet zurueck.
     Also: wenn Weglot noch nicht ready, bis zu 2s warten. */
  function triggerWeglotSwitch(targetLang) {
    var nativeBtn = document.getElementById('weglot-language-' + targetLang);
    if (!nativeBtn) return false;
    nativeBtn.click();
    return true;
  }

  function weglotReady() {
    return typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function';
  }

  document.addEventListener('click', function (e) {
    var proxy = e.target.closest('[data-weglot-proxy]');
    if (!proxy) return;
    if (!drawer.classList.contains('is-open')) return;
    e.preventDefault();
    e.stopPropagation();
    var targetLang = proxy.getAttribute('data-weglot-proxy');
    if (!targetLang) return;

    var attemptSwitch = function () {
      var nativeBtn = document.getElementById('weglot-language-' + targetLang);
      if (nativeBtn) {
        nativeBtn.click();
        return true;
      }
      if (typeof Weglot !== 'undefined' && typeof Weglot.switchTo === 'function') {
        Weglot.switchTo(targetLang);
        return true;
      }
      return false;
    };

    if (weglotReady()) {
      attemptSwitch();
      return;
    }

    var tries = 0;
    var poll = setInterval(function () {
      tries += 1;
      if (weglotReady()) {
        clearInterval(poll);
        attemptSwitch();
      } else if (tries > 20) {
        clearInterval(poll);
        attemptSwitch();
      }
    }, 100);
  });

  /* -- Aktuelle Sprache im Level-2- und Level-3-Panel dynamisch markieren --
     Weglot switcht URL-based, ohne Shopifys request.locale zu aendern. Deshalb
     gibt der serverseitig gerenderte Status ggf. DE aus, obwohl die Seite
     bereits EN anzeigt. Nach Weglot-Ready korrigieren wir Text + is-current. */
  function syncCurrentLanguage() {
    if (typeof Weglot === 'undefined' || typeof Weglot.getCurrentLang !== 'function') return;
    var currentLang = Weglot.getCurrentLang();
    if (!currentLang) return;
    var langName = currentLang === 'en' ? 'English' : 'Deutsch';

    var nameEl = document.getElementById('hs-mob-current-lang-name');
    if (nameEl) nameEl.textContent = langName;

    var flagWrap = document.getElementById('hs-mob-current-lang-flag');
    if (flagWrap) flagWrap.setAttribute('data-active-lang', currentLang);

    var utilityFlag = document.getElementById('hs-mob-utility-lang-flag');
    if (utilityFlag) utilityFlag.setAttribute('data-active-lang', currentLang);

    document.querySelectorAll('[data-weglot-proxy]').forEach(function (btn) {
      var isCurrent = btn.getAttribute('data-weglot-proxy') === currentLang;
      btn.classList.toggle('hs-mob-loc-row--current', isCurrent);
      if (isCurrent) {
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });
  }

  /* Weglot-Ready-Polling: bis 3s alle 300ms probieren. */
  var weglotPolls = 0;
  var weglotInterval = setInterval(function () {
    weglotPolls += 1;
    if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
      syncCurrentLanguage();
      clearInterval(weglotInterval);
    } else if (weglotPolls > 10) {
      clearInterval(weglotInterval);
    }
  }, 300);

  /* -- Panel-Scroll-Shadow: beim Scrollen Sticky-Header visuell abheben -- */
  document.querySelectorAll('.hs-mob-panel').forEach(function (panel) {
    panel.addEventListener('scroll', function () {
      if (panel.scrollTop > 0) {
        panel.classList.add('is-scrolled');
      } else {
        panel.classList.remove('is-scrolled');
      }
    }, { passive: true });
  });

  /* -- Swipe-Back: nach links wischen schliesst tiefstes Panel (Level 3 -> 2,
        Level 2 -> 1) bzw. den Drawer. Folgt der Animationsrichtung (Drawer
        kommt von links rein, also "wegwischen" = nach links). Gleiche Logik
        wie Escape: tiefstes Panel zuerst, dann Drawer.

        Threshold-basiert (kein Live-Drag), damit horizontale Scroll-Container
        wie .hs-mob-highlights__scroll sauber bedienbar bleiben. */
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipeStartTime = 0;
  var swipeTracking = false;

  function handleSwipeBack() {
    var activePanels = document.querySelectorAll('.hs-mob-panel.is-active');
    if (activePanels.length > 0) {
      closePanel(activePanels[activePanels.length - 1].id);
    } else {
      closeDrawer();
      if (hamburger && lastInteraction === 'keyboard') hamburger.focus({ preventScroll: true });
    }
  }

  document.addEventListener('touchstart', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.touches.length !== 1) { swipeTracking = false; return; }
    /* Touchstart in horizontalem Scroll-Container ignorieren -- sonst
       konkurriert Swipe-Back mit nativer Highlights-Scroll-Geste. */
    if (e.target.closest && e.target.closest('.hs-mob-highlights__scroll')) {
      swipeTracking = false;
      return;
    }
    var t = e.touches[0];
    swipeStartX = t.clientX;
    swipeStartY = t.clientY;
    swipeStartTime = Date.now();
    swipeTracking = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!swipeTracking) return;
    swipeTracking = false;
    if (e.changedTouches.length !== 1) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - swipeStartX;
    var dy = t.clientY - swipeStartY;
    var dt = Date.now() - swipeStartTime;
    if (dt > 500) return;                          /* zu langsam = kein Swipe */
    if (dx > -60) return;                          /* zu kurz oder nach rechts */
    if (Math.abs(dy) > Math.abs(dx) * 0.7) return; /* zu vertikal */
    handleSwipeBack();
  }, { passive: true });

  document.addEventListener('touchcancel', function () {
    swipeTracking = false;
  }, { passive: true });

})();
